/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Alert,
    Col,
    Row,
    Card,
    Accordion,
    Button,
    Form,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import { MedicalOpinionData } from "../../subPages/MedicalOpinionData/MedicalOpinionData";
import { MedicalDataAdditional } from "../../subPages/AdditionalMedicalData/MedicalDataAdditional";
import { AuthLetters } from "../../subPages/AuthLetter/AuthLetters";
import {
    getBySlug,
    update,
} from "../../services/hospitalizationcrud";
import {
    getLastLetterMovByCase,
    getLetterMovsByCase,
} from "../../services/letterMovsService";
import { MedicAssigned } from "../../subPages/MedicAssigned/MedicAssigned";
import moment from "moment";
import { isEmpty } from "../../../_utils/checkObjectEmpty";
import { MedicAssignationTrakingMedic } from "../../subPages/MedicAssignationTracking/MedicAssignationTrackingMedic";
import { IfHasRole } from "../../../../_metronic/_helpers";
import { MedicalFees } from "../../subPages/MedicalFee/MedicalFees";
import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import CaseContext from "../../../contexts/CaseContext";
import BlockCaseContext from "../../../contexts/BlockCaseContext";

const CasesCanceledDetails = (props) => {
    const suhbeader = useSubheader();
    suhbeader.setTitle("Cancelaciones");

    const { slug } = props.match.params;

    const [caseRecord, setCaseRecord] = useState({});
    const [letterMov, setLetterMov] = useState({});
    const [letterMovs, setLetterMovs] = useState([]);
    const [totalLetters, setTotalLetters] = useState("0");
    const [isFinalReject, setIsFinalReject] = useState(false);
    const [shouldBlockCase, setShouldBlockCase] = useState(true);

    useEffect(() => {
        window.wasCommented = false;
        getBySlug(slug).then((response) => {
            setCaseRecord(response.data);
            setIsFinalReject(response.data.statusDictum === "Rechazo Definitivo")
            getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
                setLetterMov(currrentLetterMov.data)
            );
        });
    }, [slug]);

    return (
        <>
            <Alert
                variant="success"
                className="text-center"
                style={{ fontSize: "16px" }}
            >
                Cancelaciones
            </Alert>

            <CaseHeader caseRecord={caseRecord} showAgentInfo={true} />

            <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
                <Accordion className="mt-5">
                    <InssuredData
                        icon="fa-search"
                        eventKey="1"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                    />
                    <HospitalData
                        icon="fa-search"
                        eventKey="2"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                    />
                    <MedicAssigned
                        icon="fa-search"
                        eventKey="7"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                    />
                    <Documentation
                        icon= "fa-search"
                        icone="fa-pencil-alt"
                        eventKey="4"
                        data={caseRecord}
                        disabledAll={true}
                        {...props}
                    />
                    <MedicalFees
                        icon= "fa-search"
                        icone="fa-pencil-alt"
                        eventKey="5"
                        data={caseRecord}
                        hideBtnInsurance={false}
                        hideFormCreate={true}
                        disabledAll={true}
                        showForm={false}
                        {...props}
                    />
                    <AuthLetters
                        icon="fa-pencil-alt"
                        showForm={false}
                        eventKey="3"
                        data={caseRecord}
                        disabledAll={true}
                        setTotalLetters={setTotalLetters}
                        {...props}
                    />
                </Accordion>
                <Accordion className="mt-5">
                    { (IfHasRole("Admin") || IfHasRole("ADMINAXA") ) && <MedicAssignationTrakingMedic
                        icon="fa-pencil-alt"
                        eventKey="0"
                        data={caseRecord}
                        mcMovement={letterMov}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                        bindErrors={() => {}}
                    /> }
                    <MedicalOpinionData
                        icon="fa-pencil-alt"
                        setIsFinalReject={setIsFinalReject}
                        eventKey="1"
                        data={caseRecord}
                        letterMov={letterMov}
                        totalLetters={totalLetters}
                        disabledAll={true}
                        bindSubmitForm={() => {}}
                        bindErrors={() => {}}
                    />
                    <MedicalDataAdditional
                        icon="fa-pencil-alt"
                        eventKey="6"
                        data={caseRecord}
                        disabled={true}
                        bindSubmitForm={() => {}}
                    />
                </Accordion>
                <Accordion defaultActiveKey="5" className="mt-5">
                    <CaseContext.Provider value={[caseRecord, setCaseRecord]}>
                        <Binnacle
                            icon="fa-pencil-alt"
                            eventKey="5"
                            data={caseRecord}
                            disabledAll={false}
                            hideButton={true}
                            hideReason={false}
                            eventStage="Cancelaciones"
                            {...props}
                        />
                    </CaseContext.Provider>
                </Accordion>
            </BlockCaseContext.Provider>
        </>
    );
};

export default CasesCanceledDetails;
